import { render, staticRenderFns } from "./share-modal-settings-link.vue?vue&type=template&id=3cfd94a0&scoped=true&"
import script from "./share-modal-settings-link.vue?vue&type=script&lang=ts&"
export * from "./share-modal-settings-link.vue?vue&type=script&lang=ts&"
import style0 from "./share-modal-settings-link.vue?vue&type=style&index=0&id=3cfd94a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfd94a0",
  null
  
)

export default component.exports